import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';
import {TimezoneObject} from '../timezones.types';
import _find from 'lodash/find';
import timezonesService from '../timezones.service';

export default async function getTimezoneObjectByAbbreviation(timezoneAbbreviation: string) {
  const dateTimeInfo = await timezonesService.getDateTimeInfo();

  return _find(
    dateTimeInfo.timezonesForSelector,
    ({abbr}: TimezoneObject) => abbr.toLowerCase() === timezoneAbbreviation.toLowerCase(),
  ) as CLSelectorOption & TimezoneObject;
}
